import styled, { css } from 'styled-components';
import { ArrowSortRegular, FilterRegular } from '@fluentui/react-icons';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 16px;
`;

export const Wrapper = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: max-content 1fr max-content;
  grid-template-rows: auto;
  grid-template-areas: 'sectionTitleMobile . iconsMobile';
  background: ${(props) => props.theme.mainBackgorund};
`;

export const Title = styled.h1`
  grid-area: sectionTitleMobile;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const IconsWrapper = styled.div`
  grid-area: iconsMobile;
  display: flex;
  flex-direction: row;
  gap: 20px;
  position: relative;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

const IconIndicator = css`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.theme.serviceDeskColorButtonRest};
`;
const Icon = css`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const ArrowSortRegularIcon = styled(ArrowSortRegular)`
  ${Icon}
`;

export const FilterRegularIcon = styled(FilterRegular)`
  ${Icon}
`;

export const FilterBadgeIndicator = styled.div`
  ${IconIndicator}
`;

export const SortBadgeIndicator = styled.div`
  ${IconIndicator}
`;
